// @flow
import { LOAD_CATALOG_BIDDING_REQUEST, LOAD_CATALOG_BIDDING_SUCCESS } from './catalogBiddingInfo';
import { LOAD_CATALOG_ITEMS_REQUEST, LOAD_CATALOG_ITEMS_SUCCESS } from './catalogItems';
import { createSelector } from 'reselect';
import difference from 'lodash/difference';
import type { GlobalState } from '../rootReducer';
import ms from 'ms';
import union from 'lodash/union';

const REDUX_STORE_TIME_CATALOG = ms('5m');

// reducer
const DEFAULT_STATE = {
    loaded: {},
    loading: [],
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    const loaded = { ...state.loaded };
    let loading = [...state.loading];
    let time;

    switch (action.type) {
        case LOAD_CATALOG_BIDDING_REQUEST:
        case LOAD_CATALOG_BIDDING_SUCCESS:
        case LOAD_CATALOG_ITEMS_REQUEST:
        case LOAD_CATALOG_ITEMS_SUCCESS:
            time = action.meta.actionTime;

            if (action.type === LOAD_CATALOG_BIDDING_REQUEST) {
                loading = union(loading, [`catalog-bidding-info-${action.payload}`]);
            }

            if (action.type === LOAD_CATALOG_BIDDING_SUCCESS) {
                const id = action.meta.catalogId;
                loaded[`catalog-bidding-info-${id}`] = time;
                loading = difference(loading, [`catalog-bidding-info-${id}`]);
            }

            // TODO: make this a pure function by moving the global
            if (action.type === LOAD_CATALOG_ITEMS_REQUEST && !global.__SERVER__) {
                loading = union(loading, [`catalog-items-${action.payload}`]);
            }

            if (action.type === LOAD_CATALOG_ITEMS_SUCCESS && !global.__SERVER__) {
                loaded[`catalog-items-${action.meta.catalogId}`] = time;
                loading = difference(loading, [`catalog-items-${action.meta.catalogId}`]);
            }

            return {
                ...state,
                loaded,
                loading,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.loaded;
const idSelector = (state: GlobalState, id) => id;

const loadedSelector = createSelector(stateSelector, state => state.loaded);

const loadingSelector = createSelector(stateSelector, state => state.loading);

const getLoadTimeForCatalogBidding = createSelector(
    [loadedSelector, idSelector],
    (loaded, id) => loaded[`catalog-bidding-info-${id}`] || 0,
);

const isCatalogBiddingLoading = createSelector([loadingSelector, idSelector], (loading, id) =>
    loading.includes(`catalog-bidding-info-${id}`),
);

export const shouldFetchBiddingInfoForCatalog = createSelector(
    [idSelector, getLoadTimeForCatalogBidding, isCatalogBiddingLoading],
    (catalogId, loaded, loading) => {
        if (!catalogId) return false;
        const time = Date.now();
        const diff = time - loaded;
        if (diff < REDUX_STORE_TIME_CATALOG) return false;
        return !loading;
    },
);

export const getLoadTimeForCatalogItems = createSelector(
    [loadedSelector, idSelector],
    (loaded, id) => loaded[`catalog-items-${id}`] || 0,
);

export const isCatalogItemsLoading = createSelector([loadingSelector, idSelector], (loading, id) =>
    loading.includes(`catalog-items-${id}`),
);
